import {
  Companion_instance20st388c71va as Companion_instance,
  access$_get_origin__hdh1qz8t4atr48tdww as access$_get_origin__hdh1qz,
  CloseToken4utf44psnuyc as CloseToken,
} from './CloseToken.mjs';
import { ClosedByteChannelException3il8gfpye60w as ClosedByteChannelException } from './Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  awaitContent$default2x8iq90jfihc1 as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SourceByteReadChannelClass;
function SourceByteReadChannel() {
  if (SourceByteReadChannelClass === VOID) {
    class $ {
      constructor(source) {
        this.x4l_1 = source;
        this.y4l_1 = null;
      }
      w4j() {
        var tmp0_safe_receiver = this.y4l_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
          var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
          var tmp_0;
          if (tmp0_subject == null) {
            tmp_0 = null;
          } else {
            if (isInterface(tmp0_subject, CopyableThrowable())) {
              tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).l13();
            } else {
              if (tmp0_subject instanceof CancellationException()) {
                tmp_0 = CancellationException().p(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
              } else {
                var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
                tmp_0 = ClosedByteChannelException().a4k(p0);
              }
            }
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      b4k() {
        return this.x4l_1.v3v();
      }
      j4j() {
        var tmp0_safe_receiver = this.w4j();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.x4l_1.u3v();
      }
      *c4k(min, $completion) {
        var tmp0_safe_receiver = this.w4j();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.x4l_1.b3w(fromInt(min));
      }
      m4k(cause) {
        if (!(this.y4l_1 == null))
          return Unit_instance;
        this.x4l_1.l6();
        var tmp = this;
        var tmp1_elvis_lhs = cause == null ? null : cause.message;
        tmp.y4l_1 = new (CloseToken())(IOException().j4i(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
      }
    }
    protoOf($).i4k = awaitContent$default;
    initMetadataForClass($, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    SourceByteReadChannelClass = $;
  }
  return SourceByteReadChannelClass;
}
//region block: exports
export {
  SourceByteReadChannel as SourceByteReadChannel1ruj5s0fyiukm,
};
//endregion

//# sourceMappingURL=SourceByteReadChannel.mjs.map
